import { AIServiceType } from "./types";

const CHART_PALETTE = [
  "#247EFE",
  "#EE46BC",
  "#9382D9",
  "#01CD8C",
  "#FAC515",
  "#EF8161",
  "#FF9F43",
  "#51E5E6",
  "#8454FF",
] as const;

interface AIServiceDefinition {
  serviceType: string;
  graphKey: string;
  displayName: string;
  description: string;
}

export const AI_SERVICES: readonly AIServiceDefinition[] = [
  {
    serviceType: AIServiceType.CORTEX_ANALYST,
    graphKey: "analyst",
    displayName: "Cortex Analyst",
    description: "Natural language to SQL query generation and analysis",
  },
  {
    serviceType: AIServiceType.CORTEX_DOCUMENT_PROCESSING,
    graphKey: "document_ai",
    displayName: "Cortex Document Processing",
    description: "Document parsing, extraction, and analysis",
  },
  {
    serviceType: AIServiceType.CORTEX_FINE_TUNING,
    graphKey: "fine_tuning",
    displayName: "Cortex Fine Tuning",
    description: "Custom model fine-tuning on your data",
  },
  {
    serviceType: AIServiceType.CORTEX_FUNCTIONS,
    graphKey: "functions",
    displayName: "Cortex Functions",
    description: "AI function calls (classify, summarize, translate, etc.)",
  },
  {
    serviceType: AIServiceType.CORTEX_SEARCH,
    graphKey: "search_daily_aggregate",
    displayName: "Cortex Search",
    description: "Semantic search indexing and serving",
  },
  {
    serviceType: AIServiceType.CORTEX_CODE_CLI,
    graphKey: "cortex_code_cli",
    displayName: "Cortex Code CLI",
    description: "Cortex-powered code generation via CLI",
  },
  {
    serviceType: AIServiceType.CORTEX_CODE_SNOWSIGHT,
    graphKey: "cortex_code_snowsight",
    displayName: "Cortex Code Snowsight",
    description: "Cortex-powered code generation via Snowsight",
  },
  {
    serviceType: AIServiceType.CORTEX_AGENT,
    graphKey: "cortex_agent",
    displayName: "Cortex Agent",
    description: "Autonomous AI agent execution and orchestration",
  },
  {
    serviceType: AIServiceType.SNOWFLAKE_INTELLIGENCE,
    graphKey: "snowflake_intelligence",
    displayName: "Snowflake Intelligence",
    description: "Snowflake Intelligence conversational analytics",
  },
];

export interface AIServiceMeta extends AIServiceDefinition {
  color: string;
}

const withColor = (def: AIServiceDefinition, index: number): AIServiceMeta => ({
  ...def,
  color: CHART_PALETTE[index % CHART_PALETTE.length],
});

export const AI_SERVICES_WITH_COLOR: readonly AIServiceMeta[] = AI_SERVICES.map(withColor);

const byServiceType = new Map(AI_SERVICES_WITH_COLOR.map(s => [s.serviceType, s]));
const byGraphKey = new Map(AI_SERVICES_WITH_COLOR.map(s => [s.graphKey, s]));

export const getServiceByType = (serviceType: string): AIServiceMeta | undefined =>
  byServiceType.get(serviceType);

export const getServiceByGraphKey = (graphKey: string): AIServiceMeta | undefined =>
  byGraphKey.get(graphKey);

export const DEFAULT_SERVICE_COLOR = CHART_PALETTE[0];

export const AGGREGATE_OPTIONS = [
  { label: "Daily", value: "day" },
  { label: "Weekly", value: "week" },
  { label: "Monthly", value: "month" },
];
